import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/styles/reset.css";
import "./assets/styles/css/mdui.min.css";
import "./assets/styles/js/mdui.min.js";

Vue.use(ElementUI);
Vue.config.productionTip = false;

new Vue({
  render: h => h(App)
}).$mount("#app");
